import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule, RouteAccessService } from '../shared';
import { RouterModule } from '@angular/router';
import { StudyEditorComponent } from './study-editor.component';
import { FormsModule } from '@angular/forms';
import { StudyDatasetComponent } from './tabs/dataset/study-dataset.component';
import { CommonModule } from '@angular/common';
import { TruncateAndTooltipDirective } from './shared/directives/truncate-and-tooltip.directive';
import { BasicDetailsComponent } from './tabs/basic-details/basic-details.component';
import { VariablesTableComponent } from './shared/variables-table/variables-table.component';
import { StudySettingsComponent } from './tabs/study-settings/study-settings.component';
import { StudyVariableSelectModalComponent } from './shared/modals/variable-select-modal/study-variable-select-modal.component';
import { StudySettingsInlineEditorComponent } from './tabs/study-settings/study-settings-inline-editor/study-settings-inline-editor.component';
import { CategoricalDisplayValuePipe } from './shared/pipes/categorical-display-value.pipe';
import { GermplasmChecksComponent } from './tabs/germplasm-checks/germplasm-checks.component';
import { StudyInlineEditorComponent } from './shared/study-inline-editor/study-inline-editor.component';
import { StudyInlineEditorDatepickerValueDirective } from './shared/directives/study-inline-editor-datepicker-value.directive';
import { STUDY_EDITOR_ROUTES } from './study-editor.route';
import { ExperimentalDesignComponent } from './tabs/experimental-design/experimental-design.component';
import { StudyEnvironmentsComponent } from './tabs/study-environments/study-environments.component';
import { CreateStudyComponent } from './create-study/create-study.component';
import { AddNewEntriesComponent } from './tabs/germplasm-checks/add-new-entries/add-new-entries.component';
import { SelectionCountComponent } from '../shared/selection-count/selection-count.component';
import { VariableBatchActionComponent } from './tabs/dataset/variable-batch-action/variable-batch-action.component';
import { ColumnSelectorComponent } from './tabs/dataset/column-selector/column-selector.component';
import { TreatmentFactorsComponent } from './tabs/treatment-factors/treatment-factors.component';
import { StudyDatasetContext } from './tabs/dataset/study-dataset.context';
import { SummaryDatasetComponent } from './tabs/summary-statistics/summary-dataset.component';
import { SummaryStatisticsComponent } from './tabs/summary-statistics/summary-statistics.component';
import { ExpandableCellComponent } from '../shared/component/expandable-cell.component';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';
import { TruncateSpanComponent } from '../shared/util/span-truncate/truncate-span.component';
import { AdditionalDesignDetailsComponent } from './tabs/experimental-design/additional-design-details/additional-design-details.component';
import { InventoryComponent } from './tabs/inventory/inventory.component';
import { SampleListComponent } from './tabs/sample-list/sample-list.component';
import { CrossesAndSelectionsComponent } from './tabs/crosses-and-selections/crosses-and-selections.component';
import { SampleGenotypeComponent } from './tabs/sample-genotype/sample-genotype.component';
import { ExeculateCalculatedVariableModalComponent } from './tabs/dataset/calculated-variable/execulate-calculated-variable-modal/execulate-calculated-variable-modal.component';
import { StudyInstancesTableSelectorComponent } from './shared/study-instances-table-selector/study-instances-table-selector.component';
import { ChangePlotEntryModalComponent } from './shared/modals/change-plot-entry-modal/change-plot-entry-modal.component';
import { AcceptPendingModalComponent } from './shared/modals/accept-pending-modal/accept-pending-modal.component';
import { ChooseDatasetModalComponent } from './shared/modals/choose-dataset-modal/choose-dataset-modal.component';
import { ChooseEnvironmentModalComponent } from './shared/modals/choose-environment-modal/choose-environment-modal.component';
import { CreateGenotypingSamplesModalComponent } from './shared/modals/create-genotyping-samples-modal/create-genotyping-samples-modal.component';
import { EditTreatmentFactorsModalComponent } from './shared/modals/edit-treatment-factors-modal/edit-treatment-factors-modal.component';
import { GeoReferenceModalComponent } from './shared/modals/geo-reference-modal/geo-reference-modal.component';
import { ObservationSampleDetailsModalComponent } from './shared/modals/observation-sample-details-modal/observation-sample-details-modal.component';
import { PlantingPreparationModalComponent } from './shared/modals/planting-preparation-modal/planting-preparation-modal.component';
import { PlotVisualizationModalComponent } from './shared/modals/plot-visualization-modal/plot-visualization-modal.component';
import { SingleEnvironmentSelectorModalComponent } from './shared/modals/single-environment-selector-modal/single-environment-selector-modal.component';
import { TransactionAdditionalDetailsModalComponent } from './shared/modals/transaction-additional-details-modal/transaction-additional-details-modal.component';
import { ExportStudyModalComponent } from './tabs/dataset/export-study/export-study-modal/export-study-modal.component';
import { SubObservationUnitDatasetBuilderModalComponent } from './tabs/dataset/sub-observation-unit-dataset-builder/sub-observation-unit-dataset-builder-modal.component';
import { ImportCrossesSettingsModalComponent } from './tabs/dataset/import-crosses/import-crosses-settings-modal/import-crosses-settings-modal.component';
import { SubObservationUnitTypeSelectorModalComponent } from './tabs/dataset/sub-observation-unit-dataset-builder/sub-observation-unit-type-selector-modal.component';
import { ImportDesignMapComponent } from './tabs/experimental-design/import-design/import-design-map/import-design-map.component';
import { ImportCrossesModalComponent } from './tabs/dataset/import-crosses/import-crosses-modal/import-crosses-modal.component';
import { ImportStudyModalComponent } from './tabs/dataset/import-study/import-study-modal/import-study-modal.component';
import { ImportDesignModalComponent } from './tabs/experimental-design/import-design/import-design-modal/import-design-modal.component';
import { ReviewDesignModalComponent } from './tabs/experimental-design/import-design/review-design-modal/review-design-modal.component';
import { ChooseListUserModalComponent } from './tabs/dataset/import-crosses/choose-list-user-modal/choose-list-user-modal.component';
import {
    ImportAdditionalDesignDetailsComponent
} from './tabs/experimental-design/additional-design-details/import-additional-design-details/import-additional-design-details.component';
import { ImportStudyMapComponent } from './tabs/dataset/import-study/import-study-map/import-study-map.component';
import { MapSectionComponent } from './tabs/experimental-design/import-design/import-design-map/map-section/map-section.component';
import { UpdateSubObservationUnitNumberModalComponent } from './tabs/dataset/update-sub-observation-unit-number/update-sub-observation-unit-number-modal.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        FormsModule,
        CommonModule,
        RouterModule.forChild(STUDY_EDITOR_ROUTES),
        CommonModule,
        SelectionCountComponent,
        ExpandableCellComponent,
        HelpLinkComponent,
        CategoricalDisplayValuePipe,
        TruncateSpanComponent,
        MapSectionComponent,
        ColumnSelectorComponent
    ],
    declarations: [
        StudyEditorComponent,
        StudyDatasetComponent,
        TruncateAndTooltipDirective,
        BasicDetailsComponent,
        VariablesTableComponent,
        StudySettingsComponent,
        StudyVariableSelectModalComponent,
        GermplasmChecksComponent,
        StudyInlineEditorComponent,
        StudyInlineEditorDatepickerValueDirective,
        StudySettingsInlineEditorComponent,
        StudyEnvironmentsComponent,
        AdditionalDesignDetailsComponent,
        ExperimentalDesignComponent,
        CreateStudyComponent,
        AddNewEntriesComponent,
        TreatmentFactorsComponent,
        SummaryDatasetComponent,
        SummaryStatisticsComponent,
        InventoryComponent,
        SampleListComponent,
        CrossesAndSelectionsComponent,
        SampleGenotypeComponent,
        ExeculateCalculatedVariableModalComponent,
        ChangePlotEntryModalComponent,
        AcceptPendingModalComponent,
        ChooseDatasetModalComponent,
        ChooseEnvironmentModalComponent,
        CreateGenotypingSamplesModalComponent,
        EditTreatmentFactorsModalComponent,
        GeoReferenceModalComponent,
        ObservationSampleDetailsModalComponent,
        PlantingPreparationModalComponent,
        PlotVisualizationModalComponent,
        SingleEnvironmentSelectorModalComponent,
        TransactionAdditionalDetailsModalComponent,
        StudyInstancesTableSelectorComponent,
        ExportStudyModalComponent,
        SubObservationUnitDatasetBuilderModalComponent,
        UpdateSubObservationUnitNumberModalComponent,
        ImportCrossesSettingsModalComponent,
        SubObservationUnitTypeSelectorModalComponent,
        ImportDesignMapComponent,
        ImportCrossesModalComponent,
        VariableBatchActionComponent,
        ImportStudyModalComponent,
        ImportDesignModalComponent,
        ReviewDesignModalComponent,
        ChooseListUserModalComponent,
        ImportAdditionalDesignDetailsComponent,
        ImportStudyMapComponent
    ],
    exports: [
        VariablesTableComponent
    ],
    providers: [
        RouteAccessService,
        CategoricalDisplayValuePipe,
        StudyInlineEditorDatepickerValueDirective,
        StudyDatasetContext
    ]
})
export class StudyEditorModule {
}
